module.exports = __webpack_public_path__ + "static/media/wordguesser.b9ed0c89.jpg";